var app = angular.module("leonardo");

var FolderFileShareDialog = function($scope, NotificationService, clipboard) {
  $scope.file = $scope.ngDialogData.file;

  $scope.url = $scope.file.secure_share_url;

  $scope.copy = function() {
    clipboard.copyText($scope.url);
    NotificationService.notify('success', 'URL copied to clipboard');
    $scope.closeThisDialog();
  };

};

app.controller('FolderFileShareDialog', ['$scope', 'NotificationService', 'clipboard', FolderFileShareDialog]);
